import {
    LitElement, html
} from 'lit-element';
import { getScript } from '../../../../utilities/utils.js';
import { raiPlayerEvents } from 'RaiPlay/assets-src/js/webcomponents/src/rai-player/player-events';
import { Subject } from 'rxjs';
import { first, takeUntil, filter } from 'rxjs/operators';
import { get as getCookie } from 'es-cookie';

import analytics from './comscore-library';

const trackEnqueue = window.Rai._trackEnqueue;

const PUBLISHER_ID = '15866303';
const TRACE_STR = "comscore tracking:";
const STATIONCODES = {
    rai_1: '0001',
    rai_2: '0002',
    rai_3: '0003',
    rai_4: '6824',
    rai_5: '7936',
    rai_sport: '6130',
    'raisport_+_hd': '6130',
    raisport_piu_hd: '6130',
    rai_sport_piu_hd: '6130',
    rai_storia: '6132',
    rai_news_24: '6095',
    rai_movie: '6055',
    rai_premium: '6058',
    rai_yoyo: '6169',
    rai_gulp: '6134',
    rai_scuola: '6131',
    raiscuola: '6131',
    raiplay: '3021',
    raiplay_2: '2037',
    raiplay_3: '2038',
    rai_sport_digital: '3022',
    raiplay_sport_1: '2042',
    raiplay_sport_2: '2043',
    raiplay_sport_3: '2044',
    raisport_web_1: '3022',
    raisport_web_2: '3022',
    raisport_web_3: '3022',
    rai_news_digital: '3023',
    raiplay_radio: '3024',
    rai_radio_2: '3024',
    rai_digital: '3025'
};
const DEBUG = document.location.search.includes("trackDebug") || !!getCookie('trackDebug');
const unsubscribe$ = new Subject();
const COMSCORE_ID = "15866303";
export default class _Comscore extends LitElement {
    static get properties() {
        return {
            pageInfo: { type: Object },
            mediaInfo: { type: Object },
            mode: { type: String },
            pageInfoBaseData: { type: Object }
        };
    }
    constructor() {
        super();
        this.pageInfo = undefined;
    }

    connectedCallback() {
        super.connectedCallback();

        /**Set the correct PlatformAPI */
        analytics.PlatformApi.setPlatformAPI(analytics.PlatformApi.PlatformApis.WebBrowser);

        /**Apply Publisher Configuration Settings */
        const myPublisherConfig = new analytics.configuration.PublisherConfiguration({
            'publisherId': PUBLISHER_ID,
            'persistentLabels': {
                'cs_ucfr': 1    /**Communicate user consent */
            }
        });
        analytics.configuration.addClient(myPublisherConfig);

        /**Debug mode */
        DEBUG && analytics.configuration.enableImplementationValidationMode();

        /**Track Page */
        this.traceDebug("Track Page");
        analytics.start();

        /**Communicate user consent */
        /* analytics.configuration.getPublisherConfiguration(PUBLISHER_ID).setPersistentLabel( 'cs_ucfr', 1 );
        analytics.notifyHiddenEvent(); */

    }
    updated() {
        !!this.mediaInfo && !this.handledEvents && this.initMediaTrack();
    }
    render() {
        return html``;
    }

    initMediaTrack() {
        let events = raiPlayerEvents.media;
        let handledEvents = [
            events.READY,
            events.REPLAY,
            events.FIRSTPLAY,
            events.ADS.STARTED,
            events.PLAYING,
            events.ADS.ADBUFFERING,
            events.ADS.ADBUFFERINGEND,
            events.ADS.RESUMED,
            events.PAUSE,
            events.BUFFERING_STARTED,
            events.BUFFERING_END,
            events.SEEK_START,
            events.SEEK_END,
            events.ENDED,
            events.ADS.COMPLETE,
            events.ADS.SKIPPED,
            events.ADS.PAUSED,
            events.ADS.ADSERROR,
            events.DISPOSE
        ];

        this.handledEvents = events;

        trackEnqueue.mediaQueue                                                                 /* media track */
            .pipe(
                filter(plEvent => handledEvents.includes(plEvent.type)),
                takeUntil(unsubscribe$)
            )
            .subscribe(plEvent => {
                try { this.trackMedia(plEvent.detail.eventData) }
                catch (e) { console.error(e); }
            });

        /**initMediaTrack */
        this.sa = new analytics.StreamingAnalytics();
    }
    getMediaInfo(event) {
        const mediaInfo = this.mediaInfo;
        const trackInfo = mediaInfo.track_info;
        const duration = Math.floor(event.mediaDuration * 1000);

        if (event.mediaType.includes('content')) {
            /** Specify content metadata */
            let cm = new analytics.StreamingAnalytics.ContentMetadata();
            cm.setMediaType(this.getMediaType(event.mediaType, duration, mediaInfo.is_live));
            cm.setMediaFormat(mediaInfo.is_live ? '*null' : this.getMediaFormat(trackInfo.form));
            cm.setDistributionModel(analytics.StreamingAnalytics.ContentMetadata.ContentDistributionModel.TV_AND_ONLINE);
            cm.setUniqueId(mediaInfo.is_live ? '*null' : trackInfo.id);
            cm.setLength(duration);
            cm.setDictionaryClassificationC3(document.referrer.includes("msn.com") ? 'raiplaymsn' : (trackInfo.domain) ? trackInfo.domain : '*null');
            cm.setDictionaryClassificationC4(mediaInfo.is_live ? 'dirette' : 'catalogo_vod');
            cm.setDictionaryClassificationC6(trackInfo.domain ? trackInfo.domain + (mediaInfo.is_live ? ' dirette' : ' on demand') : '*null');
            cm.setStationTitle(this.getStationTitle(trackInfo.channel));
            cm.setStationCode(this.getStationCode(trackInfo));
            cm.setDeliveryMode(mediaInfo.is_live ? analytics.StreamingAnalytics.ContentMetadata.ContentDeliveryMode.LINEAR : analytics.StreamingAnalytics.ContentMetadata.ContentDeliveryMode.ON_DEMAND);
            cm.setPublisherName('RAI');
            cm.setProgramTitle(mediaInfo.is_live ? '*null' : (trackInfo.program_title || '*null'));
            cm.setProgramId(
                mediaInfo.is_live ? '*null' : (
                    mediaInfo.current_program_info
                        ? mediaInfo.current_program_info.id
                        : mediaInfo.program_info
                            ? mediaInfo.program_info.id
                            : '*null'
                )
            );
            cm.setEpisodeTitle(mediaInfo.is_live
                ? '*null' : (trackInfo.episode_title || trackInfo.title)
            );
            cm.setEpisodeId((!mediaInfo.is_live && trackInfo.id) || '*null');
            cm.setEpisodeSeasonNumber(trackInfo.season || '*null');
            cm.setEpisodeNumber(trackInfo.episode_number || '*null');
            cm.setGenreName(
                (!!trackInfo.generes && !!trackInfo.generes.length
                    ? trackInfo.generes[0].name
                    : !!trackInfo.program_genres && !!trackInfo.program_genres.length
                        ? trackInfo.program_genres[0].name
                        : '*null'
                ));
            cm.classifyAsCompleteEpisode(trackInfo.form == 'integrale');
            trackInfo.listaDateMo && trackInfo.listaDateMo.length &&
                this.setDateOfTvAiring(trackInfo.listaDateMo, cm);
            cm.setDateOfDigitalAiring(trackInfo.date.split("-")[0], trackInfo.date.split("-")[1], trackInfo.date.split("-")[2]);
            cm.classifyAsAudioStream(typeof trackInfo.media_type == 'string' && trackInfo.media_type.includes('aod'));
            cm.addCustomLabels({
                'cs_proid': 'kwp-it',
                'oce_odt': mediaInfo.is_live ? '*null' : 'vod',
                'oce_bpf': trackInfo.domain,
                'oce_ctl': mediaInfo.description
            })
            this.cm = cm;

            if (event.eventName != this.handledEvents.READY) {
                /**Add media change notifications */
                this.traceDebug("SetMetadata = ↓ content " + event.eventName, cm.getStandardLabels());
                this.sa.setMetadata(cm);
            }
        } else if (event.mediaType.includes('roll')) {
            /** Specify advertisement metadata */
            let am = new analytics.StreamingAnalytics.AdvertisementMetadata();
            am.setUniqueId(event.creativeId);
            am.setMediaType(this.getMediaType(event.mediaType, duration, mediaInfo.is_live));
            am.setRelatedContentMetadata(this.cm);
            am.setLength(duration);
            this.am = am;

            /**Add media change notifications */
            this.traceDebug("SetMetadata = ↓ roll" + event.eventName, am.getStandardLabels());
            this.sa.setMetadata(am);
        } else {
            throw new Error("MediaType not handled");
        }
    }
    getStationTitle(channel) {
        if (!channel) {
            if (/raiplay/.test(window.location.href)) return 'raiplay';
            return '*null'
        }
        return channel
    };
    getStationCode(trackInfo) {
        let stationCode;
        const programChannel = trackInfo.program_info && trackInfo.program_info.channel;
        stationCode = STATIONCODES[trackInfo.channel.toLowerCase().replace(/\s+/g, '_')] || null;

        if (!stationCode && programChannel) {
            stationCode = STATIONCODES[programChannel];
        }
        stationCode = stationCode || (/raiplay/.test(window.location.href)) && STATIONCODES['raiplay'];
        stationCode = stationCode || (/rainews/.test(window.location.href)) && STATIONCODES['rai_news_digital'] || '*null';
        return stationCode;
    };
    getMediaType(mediaType, duration, live) {
        let _mediaType;
        if (mediaType.includes('content')) {
            if (!!live) {
                _mediaType = analytics.StreamingAnalytics.ContentMetadata.ContentType.LIVE;
            } else {
                !!duration
                    ? duration < (10 * 60 * 1000)
                        ? _mediaType = analytics.StreamingAnalytics.ContentMetadata.ContentType.SHORT_FORM_ON_DEMAND
                        : _mediaType = analytics.StreamingAnalytics.ContentMetadata.ContentType.LONG_FORM_ON_DEMAND
                    : _mediaType = analytics.StreamingAnalytics.ContentMetadata.ContentType.OTHER    /**fallback per mancanza duration */
            }
        };
        if (mediaType.includes('roll')) {
            if (!!live) {
                _mediaType = analytics.StreamingAnalytics.AdvertisementMetadata.AdvertisementType.LIVE;
            } else {
                if (/preroll/.test(mediaType)) _mediaType = analytics.StreamingAnalytics.AdvertisementMetadata.AdvertisementType.ON_DEMAND_PRE_ROLL;
                if (/midroll/.test(mediaType)) _mediaType = analytics.StreamingAnalytics.AdvertisementMetadata.AdvertisementType.ON_DEMAND_MID_ROLL;
                if (/postroll/.test(mediaType)) _mediaType = analytics.StreamingAnalytics.AdvertisementMetadata.AdvertisementType.ON_DEMAND_POST_ROLL;
            }
        }
        this.traceDebug("mediaType: " + mediaType, "_mediaType: " + _mediaType);
        return _mediaType;
    };
    getMediaFormat(form) {
        let _mediaFormat = document.location.pathname.includes("/raicinema/") ? 'pc' : '*null';
        switch (form) {
            case 'clip':
                _mediaFormat = 'pc';
                break;
            case 'extra':
                _mediaFormat = 'ec';
                break;
            case 'integrale':
                _mediaFormat = 'fc';
                break;
        }
        return _mediaFormat;
    }
    setDateOfTvAiring(listaDateMo, cm) {
        const today = new Date();
        listaDateMo.forEach(dataMo => {
            let dataRange = dataMo.split(";");
            let dataFrom = new Date(dataRange[0].split(" ")[0].split("/").reverse().join("-") + 'T' + dataRange[0].split(" ")[1]);
            let dataTo = new Date(dataRange[1].split(" ")[0].split("/").reverse().join("-") + 'T' + dataRange[1].split(" ")[1]);

            if (dataFrom <= today && dataTo >= today) {
                cm.setDateOfTvAiring(
                    dataFrom.getFullYear(),
                    dataFrom.getMonth(),
                    dataFrom.getDate()
                )
            }
        });
    };

    trackMedia(event) {
        let sa = this.sa;
        let events = this.handledEvents;
        let mediaInfo = this.mediaInfo;
        let currTime = event.currentTime && Math.floor(event.currentTime * 1000) || '0';
        switch (event.eventName) {
            case events.READY:
                /** Create Playback Session*/
                this.traceDebug("createPlayBackSession from READY");
                sa.createPlaybackSession();
                this.getMediaInfo(event);   /**Utile a valorizzare this.cm per accoppiare contenuto a preroll */
                break;
            case events.FIRSTPLAY:
            case events.REPLAY:
                this.firstPlayed = true;    /**Semaforo per evitare tracciamento di seek, buffering e play prima del firstPlay */
                if (mediaInfo.is_live && !!event.dvrLength) {
                    /**Specify DVR Window Length */
                    this.traceDebug("dvrLength = " + event.dvrLength * 1000);
                    sa.setDvrWindowLength(event.dvrLength * 1000);
                }
                this.getMediaInfo(event);

                this.traceDebug("StartPosition = " + currTime);
                sa.startFromPosition(currTime);
                this.traceDebug("Play Content");
                sa.notifyPlay();
                break;
            case events.ADS.STARTED:
                if (event.mediaType != 'preroll' && this.lastEvent.mediaType == 'content') {
                    this.traceDebug("End Content pre-adv");
                    sa.notifyEnd();
                }
                if (this.firstPlayed === false) { /* gestisco qui il caso del mancato evento replay quando rimando in riproduzione il contenuto */
                    this.traceDebug("createPlayBackSession from ADS.STARTED event");
                    sa.createPlaybackSession();
                }
                this.getMediaInfo(event);
                this.traceDebug("Play ADV");
                sa.notifyPlay();
                break;
            case events.BUFFERING_STARTED:
                if (this.firstPlayed) {
                    this.bufferStarted = true;
                    this.traceDebug("BufferStart");
                    sa.notifyBufferStart();
                }
                break;
            case events.BUFFERING_END:
                if (this.bufferStarted) {
                    this.bufferStarted = false;
                    this.traceDebug("BufferStop");
                    sa.notifyBufferStop();
                    if (!this.forceNextPlay) {
                        this.ignoreNextPlay = true; /*Semaforo per evitare di tracciare il play dopo ogni bufferEnd*/
                    }
                }
                break;
            case events.PLAYING:
                if (this.firstPlayed) {   /*prevent play event before first-play */
                    if (this.lastEvent.mediaType == "midroll") {
                        this.traceDebug("SetMetadata = ↓, playing midroll", this.cm.getStandardLabels());
                        sa.setMetadata(this.cm);
                    }
                    if (!this.ignoreNextPlay) {
                        this.traceDebug("Play");
                        sa.notifyPlay();
                    }
                    this.ignoreNextPlay = false;
                    this.forceNextPlay = false;
                    this.paused = false;
                }
                if (this.firstPlayed === false) { /* gestisco qui il caso del mancato evento replay quando rimando in riproduzione il contenuto */
                    this.firstPlayed = true;    /**Semaforo per evitare tracciamento di seek, buffering e play prima del firstPlay */
                    this.traceDebug("createPlayBackSession from event PLAYING");
                    sa.createPlaybackSession();
                    this.getMediaInfo(event);
                }
                break;
            case events.PAUSE:
            case events.ADS.PAUSED:
                this.traceDebug("Pause", this.cm.getStandardLabels());
                sa.notifyPause();
                this.paused = true;
                break;
            case events.ADS.ADBUFFERING:
                this.adbufferStarted = true;
                this.traceDebug("BufferStart");
                sa.notifyBufferStart();
                break;
            case events.ADS.ADBUFFERINGEND:
                if (this.adbufferStarted) {
                    this.adbufferStarted = false;
                    this.traceDebug("BufferStop");
                    sa.notifyBufferStop();
                }
                break;
            case events.ADS.RESUMED:
                sa.notifyPlay();
                this.traceDebug("Play");
                break;
            case events.ADS.COMPLETE:
            case events.ADS.SKIPPED:
                if (event.eventName == events.ADS.COMPLETE && event.mediaType == 'postroll') {
                    this.postrollPlayed = true;
                }
                this.traceDebug("End");
                sa.notifyEnd();
                break;
            case events.ADS.ADSERROR:
                if (event.mediaType == 'postroll') this.postrollPlayed = true;
                break;
            case events.SEEK_START:
                if (!this.bufferStarted && this.firstPlayed) {
                    if (!this.paused) {
                        this.traceDebug("Pause");
                        sa.notifyPause();
                    }
                    this.seekStarted = true;
                    this.traceDebug("SeekStart");
                    sa.notifySeekStart();
                }
                break;
            case events.SEEK_END:
                if (this.seekStarted) {
                    this.seekStarted = false;
                    this.traceDebug("SeekEnd, StartPosition = " + currTime);
                    sa.startFromPosition(currTime);
                    this.forceNextPlay = true;
                }
                break;
            case events.ENDED:
            case events.DISPOSE:
                if (!this.postrollPlayed) {
                    this.traceDebug("End");
                    sa.notifyEnd();
                }
                if (event.eventName == events.ENDED) {
                    this.firstPlayed = false;
                    this.postrollPlayed = false;
                }
                break;
        }
        this.lastEvent = event;
    }

    traceDebug(..._params) {
        DEBUG && console.log(TRACE_STR, _params);
    }
}
